import {
	getBubble,
	getMyConnectionId,
	getUserPrefs,
	getVideoSession,
	setVideoSession,
} from './store'
import { post } from '@/helpers/api'
import { storage } from '@/helpers/utils'

export const joinStream = async () => {
	try {
		const bubble = getBubble()
		const prefs = getUserPrefs()
		const payload = { bubble_id: bubble.id }
		if (prefs.language) {
			payload.spoken_lang = prefs.language
			storage.set('meetings_spoken_lang_pref', prefs.language)
		}
		const { data } = await post('/api/v1/videosession.join', payload)
		if (!data.ok) {
			throw new Error(data.error)
		}
		return data
	} catch (e) {
		switch (e.response?.data?.error) {
			case 'MEETINGS_DISABLED':
				return EventBus.$emit('showOverLimitWarning')
			default:
				console.error(
					e.response?.data?.error || e.message || 'Unable to join meeting'
				)
		}
		throw e
	}
}

export const postStartMuted = async (startmuted) => {
	try {
		const bubble = getBubble()
		const videosession = getVideoSession()
		const { data } = await post('/api/v1/videosession.update', {
			bubble_id: bubble.id,
			videosession_id: videosession.id,
			startmuted,
		})
		setVideoSession(data.videosession)
	} catch (e) {
		if (!e || !e.response) return
		switch (e.response.data.error) {
			default:
				console.error(e.response.data.error)
				break
		}
	}
}

export const preStream = async () => {
	try {
		const bubble = getBubble()
		const videosession = getVideoSession()
		const { data } = await post('/api/v1/videosession.prestream', {
			bubble_id: bubble.id,
			videosession_id: videosession.id,
		})
		return data
	} catch (e) {
		if (!e || !e.response) return
		switch (e.response.data.error) {
			case 'VIDEOSESSION_FULL':
				if (type === 'video') {
					EventBus.$emit('showOverLimitWarning')
				}
				break
			default:
				console.error(e.response.data.error)
				break
		}
	}
}

export const startStream = async (stream_id, type) => {
	try {
		const bubble = getBubble()
		const videosession = getVideoSession()
		const { data } = await post('/api/v1/videosession.startstream', {
			bubble_id: bubble.id,
			videosession_id: videosession.id,
			streamid: stream_id,
		})
		return data
	} catch (e) {
		if (!e || !e.response) return
		switch (e.response.data.error) {
			case 'VIDEOSESSION_FULL':
				if (type === 'video') {
					EventBus.$emit('showOverLimitWarning')
				}
				break
			default:
				console.error(e.response.data.error)
				break
		}
	}
}

export const stopStream = async (stream_id) => {
	try {
		const bubble = getBubble()
		const videosession = getVideoSession()
		const { data } = await post('/api/v1/videosession.stopstream', {
			bubble_id: bubble.id,
			videosession_id: videosession.id,
		})
		return data
	} catch (e) {
		if (!e || !e.response) return
		switch (e.response.data.error) {
			default:
				console.error(e.response.data.error)
				break
		}
	}
}

export const stopVideoSession = async () => {
	try {
		const videosession = getVideoSession()
		const { data } = await post('/api/v1/videosession.stopvideosession', {
			videosession_id: videosession.id,
		})
		setVideoSession(data.videosession)
		return data
	} catch (e) {
		if (!e || !e.response) return
		switch (e.response.data.error) {
			default:
				console.error(e.response.data.error)
				break
		}
	}
}

export const startCaptions = async () => {
	try {
		const bubble = getBubble()
		const videosession = getVideoSession()
		const connectionid = getMyConnectionId()
		const { data } = await post(
			'/api/v1/videoconnection.start_receiving_captions',
			{
				bubble_id: bubble.id,
				videosession_id: videosession.id,
				connectionid,
			}
		)
		return data
	} catch (e) {
		console.error('ERROR STARTING CAPTIONS', e)
		window.prontoAlert.error(e, { autoClose: true })
		throw e
	}
}

export const stopCaptions = async () => {
	try {
		const bubble = getBubble()
		const videosession = getVideoSession()
		const connectionid = getMyConnectionId()
		const { data } = await post(
			'/api/v1/videoconnection.stop_receiving_captions',
			{
				bubble_id: bubble.id,
				videosession_id: videosession.id,
				connectionid,
			}
		)
		return data
	} catch (e) {
		console.error('ERROR STOPPING CAPTIONS', e)
		window.prontoAlert.error(e, { autoClose: true })
		throw e
	}
}
